import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { ReadPage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface ExcludePageParams {
  pageId: string;
}

export const excludePage = async (params: ExcludePageParams): Promise<ReadPage> => {
  return await tinctApi.pages.excludePage(params.pageId);
};

export const useExcludePage = (
  options?: Omit<
    UseMutationOptions<ReadPage, ApiError, ExcludePageParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: excludePage,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['pages'] });
      queryClient.invalidateQueries({ queryKey: ['campaign'] });
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
